import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import LocalCombobox from "../Reusable/LocalComboBox";
import MultipleSelectField from "../Reusable/MultiSelectField";
import SwitchButton from "../Reusable/SwitchBtn";
import TextField from "../Reusable/TextField";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CodeData = [
  {
    name: "USD",
    id: "USD",
  },
  {
    name: "NPR",
    id: "NPR",
  },
];

const GroupForm = ({
  register,
  errors,
  setValue,
  getValues,
  clearErrors,
  control,
  watch,
  isEdit = true,
}: any) => {
  const isRest = watch("is_rest");
  return (
    <>
      <div className={tw`grid sm:grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"Group"}
          register={register("name")}
          errors={errors?.name}
          // disabled={isEdit}
        />
        <LocalCombobox
          label={"Currency"}
          placeholder={"Search currency"}
          props={{}}
          register={register("code")}
          control={control}
          errors={errors?.code}
          name={"code"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          data={CodeData}
        />
        <ComboboxInput
          url={APIS.SERVICE_TYPE}
          props={{ is_active: true }}
          queryKey={"service"}
          register={register("service")}
          errors={errors?.service}
          name={"service"}
          label={"Service Type"}
          setValue={setValue}
          placeholder={"Service Type"}
          getValues={getValues}
          disabled={true}
          clearErrors={clearErrors}
        />
        <MultipleSelectField
          errors={errors?.countries}
          label={"Country"}
          queryKey={"countries-list"}
          register={register("countries ")}
          setValue={setValue}
          watch={watch}
          props={{
            level: 0,
          }}
          url={APIS.LOCATION}
          getValues={getValues}
          clearErrors={clearErrors}
          name={"countries"}
          value={getValues("countries")}
        />
      </div>
      <div className={tw`mt-4 mb-4 mx-4 flex items-center justify-end gap-2`}>
        <span>Is Rest Country?:</span>
        <SwitchButton
          value={!!isRest}
          disabled={false}
          onChange={(val) => {
            setValue("is_rest", val, { shouldDirty: true });
          }}
        />
      </div>
    </>
  );
};

export default GroupForm;
